import React, { Component } from 'react';
import ApiService from '../../../services/Api.js';
import { APP_CONFIG, ACCION_SELECCIONADA } from '../../../utils/globales.js';
import './index.css';

// Componentes
import PaginaBiovert from '../../../components/pagina-biovert';
import BreadCrumbBiovert from '../../../components/breadcrumb-biovert';
import TablaBiovert from '../../../components/tabla-biovert';
import SelectIdioma from '../../../components/select-idioma';
import HeaderBiovert from '../../../components/header-biovert';
import ButtonBiovert from '../../../components/button-biovert';
import RawHTML from '../../../components/raw-html';
import GreyboxBiovert from '../../../components/greybox-biovert';
import SeccionAceptarCancelarBiovert from '../../../components/seccion-aceptar-cancelar-biovert';
import SeccionImagenBiovert from '../../../components/seccion-imagen-biovert';

// Notificaciones
import { toast } from 'react-toastify';

// Fontawesome
import FontAwesome from 'react-fontawesome';

class MaestrasIconosPage extends Component {

    constructor (props) {
        super(props);
        this.state = {
            listaDeIconos: null,
            idIcono: null,
            icono: {
                nombre: {
                    [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
                },
                descripcion: {
                    [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
                },
                imagen: null,
            },
            imagenAux: null,
            accionSeleccionada: ACCION_SELECCIONADA.ACCION_LIST,
            idiomaSeleccionado: APP_CONFIG.DEFAULT_SELECTED_LOCALE
        };
    }

    componentDidMount(){
        //Obtenemos la lista de iconos
        this.getIconos();
    }

    // Get iconos de la base de datos
    getIconos(){
        let requestData = {
            endpoint: APP_CONFIG.ENDPOINTS.ICONOS,
            method: 'GET',
            authorized: true,
            contentType: 'application/json'
        };
        ApiService.request(requestData)
            .then((response) => {
                this.setState({ listaDeIconos: JSON.parse(response) });
            })
            .catch((error) => {
                console.log('Error: ' + JSON.stringify(error));
            });
    }

    // Navegar dentro de la página
    nav2PageList = () => this.setState({ accionSeleccionada: ACCION_SELECCIONADA.ACCION_LIST });

    nav2PageAdd = () => this.setState({
        accionSeleccionada: ACCION_SELECCIONADA.ACCION_ADD,
        idIcono: null,
        icono: {
            nombre: {
                [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
            },
            descripcion: {
                [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
            },
        },
        imagenAux: null,
        idiomaSeleccionado: APP_CONFIG.DEFAULT_SELECTED_LOCALE
    });

    // Seleccionar idioma
    seleccionarIdioma = idioma => this.setState({ idiomaSeleccionado: idioma });

    // Formulario
    handleChangeNombre = event => {
        const s = this.state;
        s.icono.nombre[this.state.idiomaSeleccionado] = event.target.value;
        this.setState(s);
    }

    handleChangeDescripcion = event => {
        const s = this.state;
        s.icono.descripcion[this.state.idiomaSeleccionado] = event.target.value;
        this.setState(s);
    }

    handleChangeImagen = event => {
        let file = event.target.files[0];
        if (Number(file.size) > APP_CONFIG.MAX_UPLOAD_MEDIA_SIZE_BYTES){
            toast.warning(
                <div>
                    <FontAwesome name='times'/>&nbsp;<span>El archivo seleccionado es demasiado grande (límite {APP_CONFIG.MAX_UPLOAD_MEDIA_SIZE_BYTES / 1000000} MB)</span>
                </div>
            );
        } else {
            this.setState({ imagenAux: file });
        }
    }

    handleChangeEliminarImagen = () => {
        this.setState({ imagenAux: 'delete' });
    }

    // Guardar icono
    guardarFormularioIcono = () => {
        // Comprobamos campo no vacio
        if (this.state.icono.nombre[this.state.idiomaSeleccionado] == null
          || 0 >= this.state.icono.nombre[this.state.idiomaSeleccionado].length) return true;

        // Llamamos al endpoint
        const requestData = {
            endpoint: APP_CONFIG.ENDPOINTS.ICONOS,
            method: '',
            authorized: true,
            contentType: 'application/json',
            data: this.state.icono
        };

        if (null === this.state.idIcono){
            // Si es nuevo
            requestData.method = 'POST';
        } else {
            // Si estamos editando
            requestData.endpoint = requestData.endpoint + this.state.idIcono + '/';
            requestData.method = 'PUT';
        }
        ApiService.request(requestData)
            .then(response => {
                this.compruebaImagenes(Number(JSON.parse(response).id));
            })
            .catch((error) => {
                if (undefined === error.detail) toast.error(<div><FontAwesome name='times'/>&nbsp;<span>Se ha producido un error al guardar el icono</span></div>);
                else toast.error(<div><FontAwesome name='times'/>&nbsp;<span>{error.detail}</span></div>);
                console.log('Error: ' + JSON.stringify(error));
            });
    }

    // Comprobamos si hay imagen a guardar
    compruebaImagenes = id => {
        // Comprobamos si hay que eliminar
        if ('delete' === this.state.imagenAux){

            // Llamamos al endpoint para borrar imagen
            let requestData = {
                endpoint: APP_CONFIG.ENDPOINTS.ICONOS + id + '/delete_imagen/',
                method: 'DELETE',
                authorized: true,
                contentType: 'application/json'
            };
            ApiService.request(requestData)
                .then(() => {
                    this.resultadoGuardarOk();
                })
                .catch((error) => {
                    console.log('Error: ' + JSON.stringify(error));
                });

        } else if (null !== this.state.imagenAux) {

            // Upload imagen
            const formData = new FormData();
            formData.append('imagen', this.state.imagenAux);

            let requestData = {
                endpoint: APP_CONFIG.ENDPOINTS.ICONOS + id + '/upload_imagen/',
                method: 'POST',
                authorized: true,
                contentType: '',
                data: formData
            };
            ApiService.request(requestData)
                .then(() => {
                    this.resultadoGuardarOk();
                })
                .catch((error) => {
                    toast.error(<div><FontAwesome name='times'/>&nbsp;<span>{error.detail}</span></div>);
                    console.log('Error: ' + JSON.stringify(error));
                });
        } else this.resultadoGuardarOk();

    }

    // Resultado de guardar
    resultadoGuardarOk = () => {
        this.getIconos();
        toast.success(<div><FontAwesome name='check'/>&nbsp;<span>Icono guardado con éxito</span></div>);
        this.setState({
            idIcono: null,
            icono: {
                nombre: {
                    [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
                },
                descripcion: {
                    [APP_CONFIG.DEFAULT_SELECTED_LOCALE]: '',
                },
                imagen: null,
            },
            accionSeleccionada: ACCION_SELECCIONADA.ACCION_LIST
        });
    }

    // Editar icono
    editarIconoCallback = (event) => {return this.editarIcono(Number(event.target.id));}

    editarIcono = (id) => {
        // Cargamos los datos del icono
        let auxIcono = null;
        for (let i = 0; i < this.state.listaDeIconos.length; ++i){
            if (this.state.listaDeIconos[i].id === id){
                auxIcono = JSON.parse(JSON.stringify(this.state.listaDeIconos[i]));
                break;
            }
        }
        this.setState({
            accionSeleccionada: ACCION_SELECCIONADA.ACCION_EDIT,
            idiomaSeleccionado: APP_CONFIG.DEFAULT_SELECTED_LOCALE,
            idIcono: id,
            icono: auxIcono,
            imagenAux: null,
        });
    }

    // Eliminar icono
    eliminarIconoCallback = (event) => {
        let id = event.target.id;

        // Get información del elemento a eliminar
        let nombre = null;
        for (let i = 0; i < this.state.listaDeIconos.length; ++i){
            if (this.state.listaDeIconos[i].id === Number(id)){
                nombre = this.state.listaDeIconos[i].nombre[APP_CONFIG.DEFAULT_SELECTED_LOCALE];
                break;
            }
        }
        if (null === nombre) return true;
        if (window.confirm('¿Desea eliminar el icono ' + nombre + '?')){
            let requestData = {
                endpoint: APP_CONFIG.ENDPOINTS.ICONOS + id + '/',
                method: 'DELETE',
                authorized: true,
                contentType: 'application/json'
            };
            ApiService.request(requestData)
                .then(() => {
                    toast.success(<div><FontAwesome name='check'/>&nbsp;<span>Icono eliminado con éxito</span></div>);
                    this.getIconos();
                })
                .catch((error) => {
                    if (undefined === error.detail) toast.error(<div><FontAwesome name='times'/>&nbsp;<span>Se ha producido un error al eliminar el icono</span></div>);
                    else toast.error(<div><FontAwesome name='times'/>&nbsp;<span>{error.detail}</span></div>);
                    console.log('Error: ' + JSON.stringify(error));
                });
        }
    };

    calculaContenidoParaTabla(){
        // Si no hay datos
        if (this.state.listaDeIconos == null) return [];
        // Contenido
        return this.state.listaDeIconos.map(item =>
            ({
                id: item.id,
                fields: [ item.imagen, item.nombre[APP_CONFIG.DEFAULT_SELECTED_LOCALE] ],
                acciones: [
                    { label: 'Editar', callback: this.editarIconoCallback },
                    { label: 'Eliminar', callback: this.eliminarIconoCallback }
                ]
            })
        );
    }

    calculaImagenMostrar(){
        if ('delete' === this.state.imagenAux) return '';
        if (null === this.state.imagenAux) return this.state.icono.imagen;
    }

    renderListaDeElementos(){
        return ([
            <div key='elemento_lista' className='icono-container'>
                {/* Breadcrumb */}
                <BreadCrumbBiovert value = {[ 'Maestras', 'Iconos' ]}/>

                {/* Titulo + boton add */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: '20px', alignItems: 'flex-end' }}>
                    <HeaderBiovert type='t1'>Iconos</HeaderBiovert>
                    <ButtonBiovert type='primary' label='Añadir icono' handleClick={this.nav2PageAdd}/>
                </div>

                <br></br>
                <TablaBiovert cabeceras={[ 'Imagen', 'Nombre' ]} contenido={this.calculaContenidoParaTabla()} onRowClick={this.editarIcono}/>
            </div>
        ]);
    }

    renderFormulario(){

        if (null === this.state.icono) return (<div key='eci'> Error cargando el icono</div>);

        // Values
        return ([
            <div key='icono_add_edit' className='icono-container'>

                {/* Breadcrumb + seleccionar idioma */}
                <div className='icono-breadcrumb-seleccion-idioma'>
                    {this.state.accionSeleccionada === ACCION_SELECCIONADA.ACCION_ADD
                        ? <BreadCrumbBiovert value = {[ 'Maestras', 'Iconos', 'Nuevo icono' ]}/>
                        : <BreadCrumbBiovert value = {[ 'Maestras', 'Iconos', 'Editar icono' ]}/>
                    }
                    <SelectIdioma onSelect={this.seleccionarIdioma}/>
                </div>

                {/* Titulo */}
                {this.state.accionSeleccionada === ACCION_SELECCIONADA.ACCION_ADD
                    ? <HeaderBiovert type='t1'>Nuevo icono</HeaderBiovert>
                    : <HeaderBiovert type='t1'><RawHTML>{this.state.icono.nombre[this.state.idiomaSeleccionado] || '&nbsp;'}</RawHTML></HeaderBiovert>
                }

                {/* Formulario */}
                <GreyboxBiovert>
                    <div className='icono-formulario'>
                        <div className='icono-form-lbl-nombre'>
                            Nombre icono
                        </div>
                        <div className='icono-form-nombre'>
                            <input
                                id='icono-add-edit'
                                type='text'
                                value={this.state.icono.nombre[this.state.idiomaSeleccionado] || ''}
                                onChange={this.handleChangeNombre}
                                size='50'
                                className='icono-add-edit-text-input'
                            />
                        </div>
                        <div className='icono-form-lbl-nombre'>
                            Descripción icono
                        </div>
                        <div className='icono-form-nombre'>
                            <input
                                id='icono-add-edit'
                                type='text'
                                value={this.state.icono.descripcion[this.state.idiomaSeleccionado] || ''}
                                onChange={this.handleChangeDescripcion}
                                size='50'
                                className='icono-add-edit-text-input'
                            />
                        </div>
                    </div>
                </GreyboxBiovert>

                <SeccionImagenBiovert
                    titulo='Imagen icono'
                    urlImagen={this.calculaImagenMostrar()}
                    onDelete={this.handleChangeEliminarImagen}
                    onUpload={this.handleChangeImagen}/>

                <SeccionAceptarCancelarBiovert onCancel={this.nav2PageList} onAccept={this.guardarFormularioIcono}/>

            </div>
        ]);
    }

    render() {
        //Vars
        let pagina = [];

        // Añadimos los componentes en funcion de la acción seleccionada
        if (this.state.accionSeleccionada === ACCION_SELECCIONADA.ACCION_LIST) pagina.push(this.renderListaDeElementos());
        if (this.state.accionSeleccionada === ACCION_SELECCIONADA.ACCION_ADD) pagina.push(this.renderFormulario());
        if (this.state.accionSeleccionada === ACCION_SELECCIONADA.ACCION_EDIT) pagina.push(this.renderFormulario());

        return (<PaginaBiovert>{pagina}</PaginaBiovert>);
    }

}

export default MaestrasIconosPage;
